function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

function parseShopifyJson(text) {
  if (typeof text !== 'string') return null;
  const trimmed = text.trim();
  if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) return null;
  try {
    return JSON.parse(trimmed);
  } catch (e) {
    return null;
  }
}
window.parseShopifyJson = parseShopifyJson;

function fetchCartJson(url, options, retries) {
  const method = String((options && options.method) || 'GET').toUpperCase();
  const defaultRetries = method === 'GET' || method === 'HEAD' ? 1 : 0;
  const left = retries == null ? defaultRetries : retries;
  return fetch(url, options).then((response) => response.text().then((text) => {
    const json = parseShopifyJson(text);
    if (json) return json;
    if (left > 0 && (response.status === 429 || response.status === 503)) {
      return new Promise((resolve) => setTimeout(resolve, 900)).then(() => {
        return fetchCartJson(url, options, left - 1);
      });
    }
    throw new Error('cart-json');
  }));
}
window.fetchCartJson = fetchCartJson;

function cartErrorMessage() {
  return (window.theme && window.theme.strings && window.theme.strings.cartError)
    || 'There was an error while updating your cart. Please try again.';
}
window.cartErrorMessage = cartErrorMessage;

function showCartError(el, message) {
  const msg = message || cartErrorMessage();
  if (el && el.setAttribute) {
    el.setAttribute('title', msg);
    el.setAttribute('aria-label', msg);
  }
}
window.showCartError = showCartError;

function applyCartAddResponse(response) {
  if (!response) throw new Error('cart-json');
  if (response.status) {
    const err = new Error(response.description || response.message || cartErrorMessage());
    err.cartStatus = response.status;
    throw err;
  }
  const drawer = document.getElementById('Cart-Drawer');
  if (response.sections && drawer && typeof drawer.renderSections === 'function') {
    drawer.renderSections(response.sections);
  } else if (!response.sections) {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  if (typeof Cart !== 'undefined' && document.getElementById('Cart')) {
    new Cart().renderContents(response);
  }
  if (drawer && typeof drawer.open === 'function') drawer.open();
  return response;
}
window.applyCartAddResponse = applyCartAddResponse;

function fetchCartAdd(formData) {
  if (!formData.has('sections')) {
    const sections = ['cart-drawer', 'cart-bubble'];
    if (document.getElementById('Cart')) sections.unshift('main-cart');
    formData.append('sections', sections.join(','));
  }
  if (!formData.has('sections_url')) {
    formData.append('sections_url', window.location.pathname);
  }
  return fetch(`${theme.routes.cart_add_url}`, { ...FETCH_CONFIG, body: formData })
    .then((response) => response.text())
    .then((text) => {
      const json = parseShopifyJson(text);
      if (!json) throw new Error('cart-json');
      return json;
    });
}
window.fetchCartAdd = fetchCartAdd;

const FETCH_CONFIG = {
  method: 'POST',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Accept': 'application/javascript'
  }
};

const OverlayManager = {
  stack: [],
  beforeCloseHandlers: new Map(),
  cc: null,

  getCC() {
    if (!this.cc) {
      this.cc = document.querySelector('.click-capture');
    }
    return this.cc;
  },

  updateCCZIndex() {
    let cc = this.getCC();
    if (!cc) return;
    if (this.stack.length > 1) {
      let topPanel = this.stack[this.stack.length - 1];
      let topZ = parseInt(getComputedStyle(topPanel).zIndex, 10) || 90;
      cc.style.zIndex = topZ - 1;
    } else {
      cc.style.zIndex = '';
    }
  },

  open(panel) {
    if (!panel) return;
    // If already in stack, move to top
    const index = this.stack.indexOf(panel);
    if (index > -1) this.stack.splice(index, 1);
    this.stack.push(panel);
    panel.classList.add('active');
    panel.inert = false;
    document.body.classList.add('open-cc');
    this.updateCCZIndex();
    panel.querySelector('.side-panel-close')?.focus();
    dispatchCustomEvent('panel:open', { panel });
  },

  close(panel) {
    if (!panel) return;
    const index = this.stack.indexOf(panel);
    if (index > -1) this.stack.splice(index, 1);
    if (!this.stack.length) {
      document.body.classList.remove('open-cc');
    }
    this.updateCCZIndex();
    panel.classList.remove('active');
    panel.inert = true;
    dispatchCustomEvent('panel:closed', { panel });

    const handler = this.beforeCloseHandlers.get(panel);
    if (handler) handler();
  },

  closeLast() {
    const panel = this.stack[this.stack.length - 1];
    if (panel) this.close(panel);
  },

  registerBeforeClose(panel, handler) {
    this.beforeCloseHandlers.set(panel, handler);
  },

  closeAll() {
    while (this.stack.length) {
      this.closeLast();
    }
  },

  isOpen(panel) {
    return this.stack.includes(panel);
  },

  hasOpen() {
    return this.stack.length > 0;
  }
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.input = this.querySelector('.qty');
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');
      if (!this.input || !this.subtract || !this.add) return;
      this.step = Number(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', {
        bubbles: true
      });

      this.subtract.addEventListener('click', () => this.change_quantity(-this.step));
      this.add.addEventListener('click', () => this.change_quantity(this.step));
      this.rememberQty();
      this.input.addEventListener('focus', () => this.rememberQty());

      this.validateQtyRules();
      this.classList.add('buttons_added');
    }
    rememberQty() {
      const n = Number(this.input.value);
      if (Number.isFinite(n) && n > 0) this.input.dataset.previousQty = String(n);
    }
    change_quantity(change) {
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;

      const next = quantity + Number(change);
      const minAttr = this.input.getAttribute('min');
      const min = minAttr !== null && minAttr !== '' ? Number(minAttr) : 1;
      const inCart = this.closest('cart-drawer') || this.closest('#Cart') || this.classList.contains('cart-update');

      if (this.input.getAttribute('max') && next > Number(this.input.getAttribute('max'))) {
        return;
      }

      // Cart line items: stepping below min removes the line. PDP qty stays at min.
      // Do not set the input to 0 first — a failed cart/change would leave a ghost line.
      if (next < min) {
        if (inCart) {
          const drawer = this.closest('cart-drawer');
          const index = this.input.dataset.index;
          const id = this.dataset.id;
          if (drawer) {
            drawer.updateQuantity(index, 0, id);
          } else {
            document.dispatchEvent(new CustomEvent('cart:remove', { detail: { index, id } }));
          }
        }
        return;
      }

      this.input.value = next;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      const inCart = this.closest('cart-drawer') || this.closest('#Cart') || this.classList.contains('cart-update');
      if (this.input.min) {
        const min = parseInt(this.input.min);
        // Cart lines: minus at min removes the item, so keep the control clickable.
        this.subtract.classList.toggle('disabled', !inCart && value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}


/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image')
        || this.querySelector('.ks-card__image--primary');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image');
      let cachedWidth = 0;
      let currentIndex = -1;
      let rafId = null;

      const updateHover = (e) => {
        let l = e.offsetX;
        let prc = l / cachedWidth;
        let sel = Math.floor(prc * image_length);
        if (sel === currentIndex || sel < 0 || sel >= image_length) return;
        if (currentIndex >= 0) {
          images[currentIndex].classList.remove('hover');
          if (nav.length) nav[currentIndex].classList.remove('active');
        }
        currentIndex = sel;
        images[sel].classList.add('hover');
        if (nav.length) nav[sel].classList.add('active');
      };

      const mousemove = (e) => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          rafId = null;
          updateHover(e);
        });
      };

      const mouseenter = (e) => {
        cachedWidth = image_container.getBoundingClientRect().width;
        updateHover(e);
      };

      const mouseleave = () => {
        if (rafId) { cancelAnimationFrame(rafId); rafId = null; }
        if (currentIndex >= 0) {
          images[currentIndex].classList.remove('hover');
          if (nav.length) nav[currentIndex].classList.remove('active');
          currentIndex = -1;
        }
      };

      if (image_container) {
        image_container.addEventListener('touchstart', mouseenter, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mouseenter, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      if (document.readyState === 'complete') {
        images.forEach(function (image) {
          lazySizes.loader.unveil(image);
        });
      } else {
        window.addEventListener('load', () => {
          images.forEach(function (image) {
            lazySizes.loader.unveil(image);
          });
        }, { once: true });
      }
    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? (image.dataset.srcset || image.getAttribute('srcset') || '') : '';
      const isInlineSelect = swatches.closest('.ks-card--home-tabs') !== null;
      const card = isInlineSelect ? this.querySelector('.ks-card--home-tabs') : null;

      const applySwatchImage = (swatch) => {
        if (!image) return;
        const srcset = swatch.dataset.srcset || org_srcset;
        if (!srcset) return;
        image.setAttribute('srcset', srcset);
        const firstSrc = srcset.split(',')[0].trim().split(/\s+/)[0];
        if (firstSrc) image.setAttribute('src', firstSrc);
      };

      const applyInlineVariant = (swatch) => {
        let active = swatches.querySelector('.product-card-swatch.active');
        if (active) active.classList.remove('active');
        swatch.classList.add('active');
        applySwatchImage(swatch);

        if (!card) return;

        const priceNow = card.querySelector('.ks-price__now');
        const priceWas = card.querySelector('.ks-price__was');
        const priceSave = card.querySelector('.ks-price__save');
        const addBtn = card.querySelector('[data-ks-add-to-cart]');
        const chooseLink = card.querySelector('.ks-card__add:not([data-ks-add-to-cart])');

        if (priceNow && swatch.dataset.priceFormatted) {
          priceNow.textContent = swatch.dataset.priceFormatted;
        }
        if (priceWas) {
          if (swatch.dataset.compareFormatted) {
            priceWas.textContent = swatch.dataset.compareFormatted;
            priceWas.classList.remove('ks-price__was--placeholder');
          } else {
            priceWas.textContent = '\u200b';
            priceWas.classList.add('ks-price__was--placeholder');
          }
        }
        if (priceSave) {
          if (swatch.dataset.savePct) {
            priceSave.textContent = '-' + swatch.dataset.savePct + '%';
            priceSave.classList.remove('ks-price__save--placeholder');
          } else {
            priceSave.textContent = '\u200b';
            priceSave.classList.add('ks-price__save--placeholder');
          }
        }
        if (addBtn && swatch.dataset.variantId) {
          addBtn.dataset.variantId = swatch.dataset.variantId;
          addBtn.disabled = swatch.dataset.available === 'false';
        }
        if (chooseLink && swatch.dataset.href) {
          chooseLink.setAttribute('href', swatch.dataset.href);
        }
        const titleLink = card.querySelector('.ks-card__title a');
        const mediaLink = card.querySelector('.ks-card__media-link');
        if (swatch.dataset.href) {
          if (titleLink) titleLink.setAttribute('href', swatch.dataset.href);
          if (mediaLink) mediaLink.setAttribute('href', swatch.dataset.href);
        }
      };

      const unveilSwatches = () => {
        swatch_list.forEach((swatch) => {
          let img = new Image();
          img.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(img);
        });
      };
      if (document.readyState === 'complete') {
        unveilSwatches();
      } else {
        window.addEventListener('load', unveilSwatches, { once: true });
      }

      swatches.addEventListener('mouseover', (e) => {
        let swatch = e.target.closest('.product-card-swatch');
        if (!swatch) return;
        if (isInlineSelect) {
          applySwatchImage(swatch);
          return;
        }
        let active = swatches.querySelector('.product-card-swatch.active');
        if (active) active.classList.remove('active');
        swatch.classList.add('active');
        applySwatchImage(swatch);
      });

      swatches.addEventListener('mouseleave', () => {
        if (!isInlineSelect || !image) return;
        const active = swatches.querySelector('.product-card-swatch.active');
        if (active) applySwatchImage(active);
        else if (org_srcset) {
          image.setAttribute('srcset', org_srcset);
          const firstSrc = org_srcset.split(',')[0].trim().split(/\s+/)[0];
          if (firstSrc) image.setAttribute('src', firstSrc);
        }
      });

      const onSwatchActivate = (e) => {
        let swatch = e.target.closest('.product-card-swatch');
        if (!swatch) return;
        e.preventDefault();
        e.stopPropagation();
        if (isInlineSelect) {
          applyInlineVariant(swatch);
          return;
        }
        window.location.href = swatch.dataset.href;
      };

      swatches.addEventListener('click', onSwatchActivate);
      swatches.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        onSwatchActivate(e);
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);

      fetchCartAdd(formData)
        .then((response) => {
          applyCartAddResponse(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
          showCartError(this.quick_add, e && e.message);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      const sections = [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
      if (document.getElementById('Cart')) {
        sections.unshift({
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        });
      }
      return sections;
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (!html) return '';
      const el = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return el ? el.innerHTML : '';
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        const el = document.getElementById(section.id);
        if (!el || !parsedState.sections) return;
        const html = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (!html) return;
        const elementToReplace = el.querySelector(section.selector) || el;
        elementToReplace.innerHTML = html;
      }));

      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }

      let cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        let productDrawer = document.getElementById('Product-Drawer');
        if (productDrawer && OverlayManager.isOpen(productDrawer)) {
          OverlayManager.close(productDrawer);
        }
        cartDrawer.open();
      }

    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function ProductCardSmall
 */
if (!customElements.get('product-card-small')) {
  class ProductCardSmall extends HTMLElement {
    constructor() {
      super();

      this.quick_add_enabled = this.classList.contains('quick-add-to-card--true');
      this.button = this.querySelector('button');
      this.id = this.dataset.id;
      this.url = this.dataset.url;
    }
    connectedCallback() {
      if (this.quick_add_enabled) {
        this.setEventListeners();
      }
    }
    setEventListeners() {
      this.button.addEventListener('click', this.addToCart.bind(this));
    }
    getSectionsToRender() {
      const sections = [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
      if (document.getElementById('Cart')) {
        sections.unshift({
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        });
      }
      return sections;
    }

    addToCart() {
      this.button.classList.add('loading');
      if (!this.quick_add_enabled) {
        // quick view
      }
      this.button.setAttribute('aria-disabled', true);

      let formData = new FormData(this.form);

      formData.append('id', this.id);
      formData.append('quantity', 1);

      fetchCartAdd(formData)
        .then((response) => {
          applyCartAddResponse(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
          showCartError(this.button, e && e.message);
        })
        .finally(() => {
          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
        });
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        const el = document.getElementById(section.id);
        if (!el || !parsedState.sections) return;
        const html = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (!html) return;
        const elementToReplace = el.querySelector(section.selector) || el;
        elementToReplace.innerHTML = html;
      }));
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
      let cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        let productDrawer = document.getElementById('Product-Drawer');
        if (productDrawer && OverlayManager.isOpen(productDrawer)) {
          OverlayManager.close(productDrawer);
        }
        cartDrawer.open();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      if (!html) return '';
      const el = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);
      return el ? el.innerHTML : '';
    }
  }
  customElements.define('product-card-small', ProductCardSmall);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {

    connectedCallback() {
      // Each instance gets its own click handler
      this.addEventListener('click', (e) => this.close_panel(e));

      // Global listeners only once
      if (!PanelClose._initialized) {
        PanelClose._initialized = true;
        document.addEventListener('keyup', (e) => {
          if (e.code && e.code.toUpperCase() === 'ESCAPE') {
            OverlayManager.closeAll();
          }
        });
        let cc = document.querySelector('.click-capture');
        if (cc) {
          cc.addEventListener('click', () => {
            OverlayManager.closeLast();
          });
        }
      }
    }

    close_panel(e) {
      e.preventDefault();
      let panel = e.target.closest('.side-panel');
      if (panel) {
        OverlayManager.close(panel);
      }
    }
  }
  PanelClose._initialized = false;
  customElements.define('side-panel-close', PanelClose);
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      if (this._cartDrawerBound) return;
      this._cartDrawerBound = true;

      let button = document.getElementById('cart-drawer-toggle');


      // Add functionality to buttons
      button?.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.addEventListener('click', this.onRemoveClick.bind(this));

    }
    onRemoveClick(event) {
      const remove = event.target.closest('cart-remove');
      if (!remove || !this.contains(remove)) return;
      event.preventDefault();
      event.stopPropagation();
      this.updateQuantity(remove.dataset.index, '0', remove.dataset.id);
    }
    onChange(event) {
      if (!event.target.classList.contains('qty')) return;
      const input = event.target;
      const id = input.closest('quantity-selector')?.dataset.id;
      const raw = String(input.value).trim();
      const previous = Number(input.dataset.previousQty);
      if (raw === '' || !Number.isFinite(Number(raw))) {
        if (Number.isFinite(previous) && previous > 0) input.value = previous;
        return;
      }
      const qty = Number(raw);
      if (qty <= 0) {
        this.updateQuantity(input.dataset.index, 0, id);
        return;
      }
      this.updateQuantity(input.dataset.index, qty, id);
    }
    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    getSectionInnerHTML(html, selector) {
      if (!html) return '';
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector(selector) || doc.body.firstElementChild;
      return el ? el.innerHTML : '';
    }
    renderSections(sectionsMap) {
      if (!sectionsMap) return false;
      let replaced = false;
      this.getSectionsToRender().forEach((section) => {
        const el = document.getElementById(section.id);
        if (!el) return;
        const html = this.getSectionInnerHTML(sectionsMap[section.section], section.selector);
        if (!html) return;
        const elementToReplace = el.querySelector(section.selector) || el;
        elementToReplace.innerHTML = html;
        replaced = true;
      });
      this.pruneZeroQuantityLines();
      return replaced;
    }
    pruneZeroQuantityLines() {
      let removed = false;
      this.querySelectorAll('.product-cart-item').forEach((item) => {
        const q = item.querySelector('.qty');
        if (q && Number(q.value) <= 0) {
          item.remove();
          removed = true;
        }
      });
      if (
        removed &&
        !this.querySelector('.product-cart-item') &&
        !this.querySelector('.cart-drawer__empty-cart') &&
        !this._didEmptyRefresh
      ) {
        this._didEmptyRefresh = true;
        this.refresh();
      } else if (this.querySelector('.cart-drawer__empty-cart') || this.querySelector('.product-cart-item')) {
        this._didEmptyRefresh = false;
      }
    }
    updateQuantity(line, quantity, id) {
      const qty = Number(quantity);
      if (!Number.isFinite(qty)) return;
      if (this._updating) {
        const sameDelete = qty === 0 && id && this._inflightId === id && this._inflightQty === 0;
        if (!sameDelete) this._queuedChange = { line, quantity: qty, id };
        return;
      }
      this._updating = true;
      this._inflightId = id;
      this._inflightQty = qty;
      const lineItem = this.querySelector(`#CartDrawerItem-${line}`);
      const qtyInput = lineItem?.querySelector('.qty');
      const previousQty = Number(qtyInput?.dataset.previousQty);
      const revertQty = Number.isFinite(previousQty) && previousQty > 0 ? previousQty : null;
      lineItem?.classList.add('thb-loading');
      const payload = {
        quantity: qty,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
      if (id) {
        payload.id = id;
      } else {
        payload.line = line;
      }
      const body = JSON.stringify(payload);

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      fetchCartJson(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      })
        .then((parsedState) => {
          if (parsedState.errors) {
            if (qtyInput && revertQty) qtyInput.value = revertQty;
            this.refresh();
            return;
          }

          if (!parsedState.sections) {
            this.refresh();
            return;
          }

          this.renderSections(parsedState.sections);

          if (qty === 0 && this.querySelector(`#CartDrawerItem-${line}`)) {
            this.refresh();
          }

          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
        })
        .catch(() => {
          if (qtyInput && revertQty) qtyInput.value = revertQty;
          this.refresh();
        })
        .finally(() => {
          this._updating = false;
          this._inflightId = null;
          this._inflightQty = null;
          lineItem?.classList.remove('thb-loading');
          const queued = this._queuedChange;
          this._queuedChange = null;
          if (queued) this.updateQuantity(queued.line, queued.quantity, queued.id);
        });
    }
    open() {
      OverlayManager.open(this);
      dispatchCustomEvent('cart-drawer:open');
    }
    refresh() {
      fetchCartJson(`${window.location.pathname}?sections=cart-drawer,cart-bubble`)
        .then((parsedState) => {
          this.renderSections(parsedState);
        })
        .catch(() => {});
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}


/**
 *  @class
 *  @function CustomSelect
 */
if (!customElements.get('custom-select')) {
  class CustomSelect extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.detailsements = {
        form: this.closest('form'),
        input: this.querySelector('input'),
        button: this.querySelector('.custom-select--button'),
        panel: this.querySelector('.custom-select--list'),
      };
      this.autoClose = this.dataset.autoClose;
      this.detailsements.button.addEventListener('click', this.toggleSelector.bind(this));
      this.detailsements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.detailsements.panel?.querySelectorAll('button').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.detailsements.button.setAttribute('aria-expanded', 'false');
      this.classList.remove('custom-select--active');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.detailsements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.detailsements.input.value = event.currentTarget.dataset.value;
      this.detailsements.input.dispatchEvent(new Event('change'));
      this.detailsements.button.querySelector('.custom-select--text').textContent = event.currentTarget.textContent;
      if (this.detailsements.form) {
        this.detailsements.form.dispatchEvent(new Event('input'));
      }
      if (this.autoClose) {
        this.classList.remove('custom-select--active');
      }
    }

    toggleSelector(event) {
      event.preventDefault();
      this.classList.toggle('custom-select--active');
      if (this.classList.contains('custom-select--active')) {
        this.detailsements.button.focus();
        this.detailsements.button.setAttribute('aria-expanded', (this.detailsements.button.getAttribute('aria-expanded') === 'false').toString());
      } else {
        this.hidePanel();
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.classList.contains('custom-select--button');
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('custom-select', CustomSelect);
}
/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('input[name="locale_code"], input[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
          e.preventDefault();
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');
      if (!this.details || !this.summary || !this.content) {
        return;
      }
      this.setListeners();
    }
    setListeners() {
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        this.classList.add('product-recommendations--loaded');

      })
      .catch(e => {
        console.error(e);
      });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  const _cache = new Map();

  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.drawerContent = this.drawer.querySelector('#Product-Drawer-Content');

      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      OverlayManager.registerBeforeClose(this.drawer, () => {
        document.body.classList.remove('open-cc--product');
        setTimeout(() => {
          if (!this.drawer.classList.contains('active')) {
            this.drawerContent.innerHTML = '';
          }
        }, 260);
      });
    }
    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
    }
    _onClick(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle;
      if (!productHandle || this.classList.contains('loading')) {
        return;
      }

      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;
      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');

      if (_cache.has(productHandle)) {
        this.renderQuickview(_cache.get(productHandle), href, productHandle);
        return;
      }

      this.classList.add('loading');
      fetch(href)
        .then((response) => response.text())
        .then((text) => {
          this.classList.remove('loading');
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          _cache.set(productHandle, sectionInnerHTML);
          this.renderQuickview(sectionInnerHTML, href, productHandle);
        })
        .catch(() => {
          this.classList.remove('loading');
        });
    }
    _reloadScripts(container) {
      let scripts = container.querySelectorAll('script');
      let head = document.head;
      scripts.forEach((oldScript) => {
        let newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        if (oldScript.src) {
          if (document.querySelector(`script[src="${oldScript.src}"]`)) {
            return;
          }
        } else {
          newScript.textContent = oldScript.textContent;
        }
        if (oldScript.parentNode) {
          oldScript.parentNode.replaceChild(newScript, oldScript);
        } else {
          head.appendChild(newScript);
        }
      });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML) {
        return;
      }

      let drawerContent = this.drawer.querySelector('#Product-Drawer-Content');
      drawerContent.innerHTML = sectionInnerHTML;

      this._reloadScripts(drawerContent);

      OverlayManager.open(this.drawer);
      document.body.classList.add('open-cc--product');

      requestAnimationFrame(() => {
        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
        if (window.ProductModel) {
          window.ProductModel.loadShopifyXR();
        }
        let slider = this.drawer.querySelector('#Product-Slider');
        if (slider) {
          slider.reInit();
        }
        window.dispatchEvent(new Event('resize'));
      });

      dispatchCustomEvent('quick-view:open', {
        productUrl: href,
        productHandle: productHandle
      });

      addIdToRecentlyViewed(productHandle);
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function AnimatedMarkers
 */
class AnimatedMarkers {

  constructor() {
    this.markers = document.querySelectorAll('.svg-marker path');
    this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';

    if (this.animations_enabled && this.markers.length) {
      this.setupEventListeners();
    }
  }
  setupEventListeners() {
    this.markers.forEach((marker, i) => {
      gsap.from(marker, {
        duration: 1,
        ease: 'power4.inOut',
        drawSVG: "0%",
        scrollTrigger: {
          trigger: marker,
          start: 'top 70%',
          end: 'bottom 80%'
        }
      });
    });
  }

}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {

  if (typeof AnimatedMarkers !== 'undefined') {
    new AnimatedMarkers();
  }

});